import { StockTable } from 'components/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useMemo } from 'react';
import { useConfigByCountry, usePageTitle } from 'routes/Util/Util.hooks';
import { useStocksQuery } from 'components/Stock/Stock.hooks';
import { Stock } from 'components/Stock/Stock.helper';
import { StockTableLoader } from 'components/Table/StockTableLoader';
import { countryTextMap } from 'routes/Util/Util.helper';
import { ContryContextType } from 'routes/CountryPage';
import { useOutletContext } from 'react-router-dom';
import { TableFilterFormik } from 'components/Forms/TableFilter';

export const TablePage = () => {
  const { countryCode } = useOutletContext<ContryContextType>();
  const country = countryCode.toLowerCase();

  usePageTitle(`${countryTextMap[countryCode]} 테이블`);

  const { symbolsBySector } = useConfigByCountry(country);
  const { data: stocks, isLoading } = useStocksQuery(country);
  const sectors = useMemo(() =>
    Object.keys(symbolsBySector).filter(sec => symbolsBySector[sec].length > 0)
  , [symbolsBySector]);
  const stocksBySector = useMemo(() => {
    const stocksBySector: { [key: string]: Stock[] } = {};
    for (const sector of sectors) {
      stocksBySector[sector] = stocks
        .filter(stock => stock.sector === sector)
        .sort((a, b) => b.marketCap - a.marketCap);
    }
    return stocksBySector;
  }, [stocks, sectors]);

  return (
    <>
      <Row>
        <Col>
          <TableFilterFormik />
        </Col>
      </Row>
      <Row>
        {sectors.map(sector => (
          <Col key={sector} sm={12} md={6} lg={4} xl={3}>
            {isLoading ? (
              <StockTableLoader />
            ) : (
              <StockTable country={country} sector={sector} stocks={stocksBySector[sector]} />
            )}
          </Col>
        ))}
      </Row>
    </>
  )
}
